import LevelBase from "./levelBase";
import { Empty, Exit, Interactive, NPCharacter, Player } from "../objects";
import { translate } from "../../utils/localization";
import UI from "../UI";
import { PIXEL_NAME, SCALE, TICK_TIME } from "../../utils/constants";
import template from 'lodash.template'
import dbManager from "../../utils/dbManager";

class Level8 extends LevelBase {
  constructor() {
    super();
    this.name = "The Sisyphean task";
    this.diamondsGoal = 40;
    this.dwarf = null;
    this.broSprite = null;
    this.grayscalePipeline = null;
    this.tripMusic = null
    this.firstVisit = true
    this.tookTheTrip = false
  }

  get id() {
    return this.constructor.key
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);

    this.tookTheTrip = await dbManager.get('tripDone') || false

    if(!this.tookTheTrip) {
      this.broSprite = this.scene.add.sprite(48, 16).setOrigin(0, 0.25);
      this.broSprite.setScale(SCALE);
      this.broSprite.play("bro_idle");
      this.broSprite.x = this.dwarf.alien.x + UI.tileToScreen(12);
      this.broSprite.y = this.dwarf.alien.y;
  
      this.grayscalePipeline = this.scene.renderer.pipelines.get("Gray");
      this.player.alien.setPipeline(this.grayscalePipeline);
  
      this.tripMusic = this.scene.sound.add('swarf_chat_music', { loop: true, valume: 0 })
    } else {
      // ===================
      // removes NPC (dwarf)
      // ===================
      this.replaceByEmpty(this.leader);
      this.leader.alien.destroy();
      this.leader = null;
      // ================================
      // removes usless interactive spots
      // ================================
      Object.keys(this.interactiveElements).forEach(
        (k) => {
          // removes if is not the exit
          if(!this.interactiveElements[k].isClass(Exit)) {
            this.interactiveElements[k] = null
          }
        }
      );
    }
  }

  async onComplete() {
    await dbManager.set('tripDone', this.tookTheTrip)
    super.onComplete()
  }

  onInteractWith(el) {
    super.onInteractWith(el);
    // talk to Doc
    if (el.order === 0) {
      if(this.firstVisit) {
        if(this.totalShroomsAmount > 0) {
          this.showDialog1()
        } else {
          this.showDialog1NoShroom()
        }
      } else {
        this.showDialog1Revisit()
      }
      this.firstVisit = false
    }
    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

    if(el.isClass(Interactive)) {
      el.ephemeral = false
    }

    if (el.isClass(NPCharacter)) {
      el.isCloseEnough = () => false;
      this.dwarf = el;
    }
  }

  showDialog1NoShroom() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1_no_shrooms.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_8.dialog_1_no_shrooms.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1_no_shrooms.mary_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [template(translate("level_8.dialog_1_no_shrooms.dwarf_say_2"))({NUM: 5})],
        },
      ]
    })
  }
  showDialog1Revisit() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Dwarf",
          text: [translate("level_8.dialog_1_repeat.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1_repeat.mary_say_1")],
          options: {
            slot0: {
              label: translate("level_8.dialog_1_option.yes"),
              slot: 0,
              onSelect: () => this.scene.events.emit("dialogue:nextPage"),
            },
            slot1: {
              label: translate("level_8.dialog_1_option.no"),
              slot: 1,
              onSelect: () => this.scene.events.emit("dialogue:nextPage", 1),
            },
            slot2: null,
            slot3: null,
          }
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1_repeat.mary_say_2_yes")],
          options: {
            slot2: null, // hide default NEXT option
            slot3: {
              label: translate("menu.dialog_options.close"),
              slot: 3,
              onSelect: () => {
                this.scene.events.emit("dialogue:hide");
                this.scene.events.once("dialogue:hidden", () => {
                  this.playTheTrip();
                  this.scene.events.emit("score:mushroom_given")
                  this.collectedShrooms--
                  // flag trip done in current level.
                  // it will save in DB after level completes.
                  this.tookTheTrip = true
                });
              },
            },
          },
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1_repeat.mary_say_2_no")],
        },
      ]
    })
  }
  showDialog1() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_8.dialog_1.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1.mary_say_2")],
          options: {
            slot0: {
              label: translate("level_8.dialog_1_option.yes"),
              slot: 0,
              onSelect: () => this.scene.events.emit("dialogue:nextPage"),
            },
            slot1: {
              label: translate("level_8.dialog_1_option.no"),
              slot: 1,
              onSelect: () => this.scene.events.emit("dialogue:nextPage", 1),
            },
            slot2: null,
            slot3: null,
          },
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1.mary_say_3_yes")],
          options: {
            slot2: null, // hide default NEXT option
            slot3: {
              label: translate("menu.dialog_options.close"),
              slot: 3,
              onSelect: () => {
                this.scene.events.emit("dialogue:hide");
                this.scene.events.once("dialogue:hidden", () => {
                  this.playTheTrip();
                  this.scene.events.emit("score:mushroom_given")
                  this.collectedShrooms--
                  // flag trip done in current level.
                  // it will save in DB after level completes.
                  this.tookTheTrip = true
                });
              },
            },
          },
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_8.dialog_1.mary_say_3_no")],
        },
      ],
    });
  }

  showDialog2() {
    return new Promise((res) => {
      this.scene.events.emit("dialogue:show", {
        participants: ["closeUp_Dwarf", "closeUp_Marduk"],
        participantNames: ["Doc", "Marduk"],
        conversation: [
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_2.dwarf_say_1")],
          },
          {
            who: "closeUp_Marduk",
            text: [translate("level_8.dialog_2.marduk_say_1")],
          },
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_2.dwarf_say_2")],
          },
          {
            who: "closeUp_Marduk",
            text: [translate("level_8.dialog_2.marduk_say_2")],
          },
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_2.dwarf_say_3")],
          },
          {
            who: "closeUp_Marduk",
            text: [translate("level_8.dialog_2.marduk_say_3")],
          },
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_2.dwarf_say_4")],
          },
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_2.dwarf_say_5")],
          },
          {
            who: "closeUp_Marduk",
            text: [translate("level_8.dialog_2.marduk_say_4")],
          },
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_2.dwarf_say_6")],
          },
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_2.dwarf_say_7")],
          },
        ],
      });

      this.scene.events.once("dialogue:hidden", () => {
        setTimeout(res, 500);
      });
    });
  }

  showDialog3() {
    return new Promise((res) => {
      this.scene.events.emit("dialogue:show", {
        participants: ["closeUp_Mary", "closeUp_Dwarf"],
        participantNames: ["Mary", "Doc"],
        conversation: [
          {
            who: "closeUp_Mary",
            text: [translate("level_8.dialog_3.mary_say_1")],
          },
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_3.dwarf_say_1")],
          },
          {
            who: "closeUp_Mary",
            text: [translate("level_8.dialog_3.mary_say_2")],
          },
          {
            who: "closeUp_Dwarf",
            text: [translate("level_8.dialog_3.dwarf_say_2")],
          },
        ],
      });
      this.scene.events.once("dialogue:hidden", () => {
        setTimeout(res, 500);
      });
    });
  }

  async playTheTrip() {
    this.player.disconnect();
    await this.animFadeOutLevel();
    await this.moveCamera();
    this.animPlayerAndDwarf();
    await this.animBroEntrance();

    await this.showDialog2();
    await this.vanishBro();
    await this.animDwarfMoveCloseToPlayer();
    await this.showDialog3();

    await this.vanishDwarf()

    await this.animFadeInLevel()

    this.restoreRegularGamePlay()
  }
  
  async restoreRegularGamePlay() {
    // remove interactive element
    this.interactiveElements[`${this.player.position.x}-${this.player.position.y}`] = null
    // remove dwarf presence in map
    this.setObjectAt(
      this.dwarf.position.x,
      this.dwarf.position.y,
      new Empty(PIXEL_NAME.EMPTY, this)
    )

    await this.scene.rules.panAndFollow(this.player.alien)
    this.player.reconnect()
  }

  vanishDwarf() {
    return new Promise((res) => {
      // reposition player sprite
      this.scene.tweens.add({
        targets: this.player.alien,
        x: this.player.alien.x + UI.tileToScreen(2),
        duration: 3000,
        ease: "Linear",
        onComplete: () => {
        },
      });
      // grayscale NPC
      this.scene.tweens.add({
        targets: [this.dwarf.alien],
        duration: 3000,
        alpha: 0,
        x: this.dwarf.alien.x + UI.tileToScreen(2),
        onComplete: res
      })

      // music transition
      this.scene.tweens.add({
        targets: this.scene.rules.music,
        volume: 1,
        delay: 1500,
        ease: 'Linear',
        duration: 1000,
      });
      
      this.scene.tweens.add({
        targets: this.tripMusic,
        volume: 0,
        ease: 'Linear',
        duration: 1000,
        onComplete: () => this.tripMusic.stop()
      });
    })
  }

  vanishBro() {
    return new Promise((res) => {
      this.scene.tweens.add({
        targets: this.broSprite,
        duration: 2000,
        alpha: 0,
        onComplete: res
      });
    });
  }

  async animBroEntrance() {
    return new Promise((res) => {
      // move bro
      this.scene.tweens.add({
        targets: this.broSprite,
        x: this.broSprite.x - UI.tileToScreen(10),
        duration: TICK_TIME * 10,
        ease: "Linear",
        delay: TICK_TIME * 10,
        onComplete: () => {
          this.player.animIdle();
          this.dwarf.animIdle();
          this.dwarf.animRunRight();
          res();
        },
      });
    });
  }

  animDwarfMoveCloseToPlayer() {
    return new Promise((res) => {
      this.dwarf.animRunLeft();
      this.dwarf.animRun();

      // move player left and play run right
      this.scene.tweens.add({
        targets: this.dwarf.alien,
        x: this.dwarf.alien.x - UI.tileToScreen(1),
        duration: TICK_TIME,
        ease: "Linear",
        onComplete: () => {
          this.dwarf.animIdle();
          this.dwarf.animRunRight();
          // colorize player
          this.scene.tweens.add({
            targets: this.grayscalePipeline,
            duration: 1000,
            gray: 0,
            completeDelay: 1000,
            onComplete: res,
          });
        },
      });
    });
  }

  animPlayerAndDwarf() {
    this.dwarf.animRunRight();
    this.dwarf.animRun();

    // move player left and play run right
    this.scene.tweens.add({
      targets: this.player.alien,
      x: this.player.alien.x - UI.tileToScreen(2),
      duration: TICK_TIME * 2,
      ease: "Linear",
      onComplete: () => {
        this.player.animRun();
      },
    });
  }

  async moveCamera() {
    // replace focus element (currently the player) for a position object relative to the dwarf
    return this.scene.rules.panAndFollow({ x: this.dwarf.alien.x + 5, y: this.dwarf.alien.y, width: 1, height: 1 })
  }

  async animFadeInLevel() {
    return new Promise((res) => {
      this.scene.tweens.add({
        targets: { alpha: 0 },
        alpha: 1,
        ease: "Linear",
        duration: 2000,
        onUpdate: (tween, target) => {
          this.setLevelAlpha(target.alpha);
        },
        onComplete: res,
      });
    })
  }
  async animFadeOutLevel() {
    return new Promise((res) => {
      this.scene.tweens.add({
        targets: this.grayscalePipeline,
        delay: 1000,
        duration: 1000,
        gray: 1,
      });
      this.scene.tweens.add({
        targets: { alpha: 1 },
        alpha: 0,
        ease: "Linear",
        duration: 1000,
        onUpdate: (tween, target) => {
          this.setLevelAlpha(target.alpha);
        },
        onComplete: res,
      });
      // music transition
      this.scene.tweens.add({
        targets: this.scene.rules.music,
        volume: 0,
        ease: 'Linear',
        duration: 1000,
      });
      this.tripMusic.volume = 0
      this.tripMusic.play()
      this.scene.tweens.add({
        targets: this.tripMusic,
        volume: 1,
        delay: 500,
        ease: 'Linear',
        duration: 1000,
      });
    });
  }

  setLevelAlpha(value) {
    const layer_1 = this.scene.children.getByName("layer_1");
    const layer_1z2 = this.scene.children.getByName("layer_1z2");
    const layer_2 = this.scene.children.getByName("layer_2");
    const layer_0 = this.scene.children.getByName("layer_0");
    const level_background_art = this.scene.children.getByName(
      "level_background_art"
    );
    layer_1.setAlpha(value);
    layer_1z2.setAlpha(value);
    layer_2.setAlpha(value);
    layer_0.setAlpha(value);
    level_background_art.setAlpha(value / 4);
    this.objects.forEach((row) =>
      row.forEach((el) => {
        if (el.alien && !el.isClass(Player) && !el.isClass(NPCharacter)) {
          el.alien.setAlpha(value);
        }
      })
    );
    Object.values(this.decorationElements).forEach((el) =>
      el.alien.setAlpha(value)
    );
  }

}

Level8.key = "level_8";
export default Level8;
